<template>
  <b-modal ref="modal-blocnote" :id="id" hide-footer centered no-fade static>
    <template slot="modal-header">
      <b-button class="close" aria-label="fermer" @click="hideModal(id)">X</b-button>
    </template>

    <div class="row">
      <div class="col-sm-3 d-flex justify-content-center align-items-center">
        <img :src="popupImage" class="img-fluid" :alt="altPopupImage" />
      </div>
      <div class="col-sm ml-2">
        <slot></slot>
      </div>
    </div>
    <div v-if="showNoButton()">
      <p class="centered-element">{{ LG("PP_KeepClueMessage") }}</p>
      <br />
    </div>
    <div class="centered-element">
      <b-button class="funky-shape" v-on:click="onPopupOkButtonClicked(id)" ref="OKRef">{{ getOkButtonLabel() }}</b-button>
      <b-button v-if="showNoButton()" class="funky-shape button-red ml-4" v-on:click="onPopupNoButtonClicked(id)" ref="NORef">{{ getNoButtonLabel() }}</b-button>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "PopupOverlay",
  props: {
    id: {
      type: String,
      default: "id-popup-overlay",
    },
    popupBg: {
      type: String,
      default: "@/assets/menus/popups/popup_bg.png",
    },
    popupImage: {
      type: String,
    },
    imageWidth: {
      type: String,
      default: "300",
    },
    altPopupImage: {
      type: String,
      default: "",
    },
    okButtonLabel: {
      type: String,
      default: "COMMENCER",
    },
    choices: {
      type: String,
      default: "no",
    },
  },
  data() {
    return {
      // Text
      // Images
      // Variables
      // lastFocussedElement: null,
    };
  },
  // mounted() {
  //   this.focusPopup();
  // },
  mounted() {
    this.$root.$on("bv::modal::hide", () => {
      this.onPopupCloseButtonClicked();
    });
  },
  computed: {},
  // created() {
  //   document.addEventListener("keyup", this.onKeyUp);
  // },
  // destroyed() {
  //   document.removeEventListener("keyup", this.onKeyUp);
  // },
  methods: {
    // onKeyUp(e) {
    //   // Check for TAB
    //   if (e.keyCode == 9) {
    //     var activeElement = document.activeElement;
    //     var mainButtonElement = this.$refs.OKRef;
    //     if (this.showNoButton()) {
    //       mainButtonElement = this.$refs.NORef;
    //     }

    //     if (e.shiftKey) {
    //       if (this.lastFocussedElement == this.$refs.closeButtonRef) {
    //         //console.log("TABBED BACKWARD onto the CLOSE button! foccussing the OK button!");
    //         mainButtonElement.focus();
    //       }
    //       //else {
    //       //    console.log("TABBING BACKWARDS ELSEWHERE!!!");
    //       //}
    //     } else {
    //       // If your last focus was the OK or NO button, and now you have tabbed out, tab back to the close button
    //       if (this.lastFocussedElement == mainButtonElement) {
    //         //console.log("TABBED onto the OK button! foccussing the close button!");
    //         this.$refs.closeButtonRef.focus();
    //       }
    //       //else {
    //       //    console.log("TABBING ELSEWHERE!!!");
    //       //}
    //     }
    //     this.lastFocussedElement = activeElement;
    //   }
    //   //else {
    //   //    console.log(e.keyCode + " was pressed!");
    //   //}
    // },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    getPopupCloseButtonClass() {
      //if (this.newVersion()) {
      //    return "popup-close-button-new";
      //}
      // TBD - we now use the old close button again for the newer new :-)
      return "popup-close-button";
    },

    showNoButton() {
      if (this.choices == "yes" && this.newVersion()) {
        return true;
      }
      return false;
    },
    getOkButtonLabel() {
      if (this.choices == "yes" && this.newVersion()) {
        return this.LG("G_YesButtonLabel");
      }
      return this.okButtonLabel;
    },
    getNoButtonLabel() {
      return this.LG("G_NoButtonLabel");
    },
    // focusPopup() {
    //   this.$refs.OKRef.focus();
    // },
    onPopupCloseButtonClicked() {
      this.$emit("close-clicked");
    },
    onPopupOkButtonClicked(id) {
      this.hideModal(id);
      this.$emit("ok-clicked");
    },
    onPopupNoButtonClicked(id) {
      this.hideModal(id);
      this.$emit("no-clicked");
    },
    getCharacterCss() {
      var offsetX = Number(this.imageWidth) * -0.4;
      var style = "position: absolute;  top: 0px; left: " + offsetX + "px;";
      return style;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
@import url("https://fonts.googleapis.com/css?family=Poppins");

.popup-close {
  position: absolute;
  top: -20px;
  right: 30px;
  font-size: 40px;
  color: white;
}

.x-text {
  position: relative;
  bottom: 0px;
}

.popup-close-button {
  background-color: #3f5d12;
  border: 3px solid white;
  border-radius: 50%;
  color: white;
  width: 65px;
  height: 65px;
}

.popup-close-button:hover {
  background-color: gray;
}

.popup-close-button:focus {
  outline: none !important;
  background-color: gray;
}

.bg-popup-area {
  position: relative;
  background-color: white;
  color: black;
  font-family: "Poppins";
  font-size: 17px;
  width: 70%;
  max-width: 1000px;
  min-height: 350px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  padding: 25px;
}

.bg-popup-area-new {
  border-radius: 50px;
  border: 10px solid #ffffff;
  max-width: 1300px !important;
  background-color: #f3f3f3 !important;
}

.popup-screen-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 105%;
  color: white;
  backdrop-filter: blur(6px);
}

.button-red {
  background-color: #c02234 !important;
}

.button-red:hover {
  background-color: #c74c22 !important;
}

.button-red:focus {
  background-color: #c74c22 !important;
}
</style>

<style scoped>
/* Modal */
::v-deep .modal-dialog {
  max-width: 1200px;
  margin-top: 40px;
}
::v-deep .modal-header {
  border: none;

  height: 0px;
}
::v-deep .modal-header .close {
  opacity: 1;

  background-color: #3f5d12;
  border: 3px solid white;
  border-radius: 50%;
  color: white;
  width: 65px;
  height: 65px;

  font-weight: 500;
  font-size: 40px;
  padding: 2px;

  position: relative;
  top: -52px;
}

::v-deep .modal-header .close:hover,
::v-deep .modal-header .close:focus,
::v-deep .modal-header .close:active {
  opacity: 1;
  background-color: gray;
}
::v-deep .modal-title {
  font-size: 1.7rem;
  font-weight: 600;
  margin-left: auto;
}

::v-deep .modal-content {
  border-radius: 57px;
  border: 10px solid #ffffff;
  background-color: #eaeaea;
  font-family: "Poppins";
  font-size: 17px;
  color: black;
  padding: 25px;
  /* min-height: 640px; */
}

::v-deep .modal-backdrop {
  opacity: 1;
  background-color: rgba(0, 0, 0, 0.55);
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
}
</style>
